<template>
  <div class="page-container full-height">
    <md-app class="full-height" md-mode="fixed">
      <md-app-toolbar v-if="deveExibirMenu" class="md-primary">
        <md-button
          v-if="!menuVisible"
          class="md-icon-button"
          @click="toggleMenu"
        >
          <md-icon class="fa fa-bars"> menu</md-icon>
        </md-button>

        <div>
          <router-link :to="{ name: 'Home' }">
            <span class="md-title">
              <span>{{ appName }}</span>
            </span>
          </router-link>
          <router-link
            v-if="localName"
            :to="{
              name: 'DashboardIndex',
              params: { localId: $route.params.localId },
            }"
          >
            <span class="md-title">
              <span>- {{ localName }}</span>
            </span>
          </router-link>
        </div>

        <div class="md-toolbar-section-end">
          <!--<md-button class="md-icon-button">
                        <md-icon class="fa fa-bars">person</md-icon>
                    </md-button>-->

          <span class="md-title" style="z-index: 999"> {{ nome }}</span>
        </div>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <md-toolbar class="md-transparent" md-elevation="0">
          <span>Menu</span>
          <div class="md-toolbar-section-end">
            <md-button class="md-icon-button md-dense" @click="toggleMenu">
              <md-icon>keyboard_arrow_left</md-icon>
            </md-button>
          </div>
        </md-toolbar>

        <md-list>
          <md-list-item :to="{ name: 'Home' }">
            <md-icon>home</md-icon>
            <span class="md-list-item-text">Início</span>
          </md-list-item>

          <md-list-item :to="{ name: 'LocalIndex' }">
            <md-icon>add_location</md-icon>
            <span class="md-list-item-text">Locais</span>
          </md-list-item>

          <md-list-item v-if="isAdmin()" :to="{ name: 'usuarios' }">
            <md-icon>people</md-icon>
            <span class="md-list-item-text">Usuários</span>
          </md-list-item>

          <md-list-item v-if="isAdmin()" :to="{ name: 'ApkVersionIndex' }">
            <md-icon>phone_android</md-icon>
            <span class="md-list-item-text">Aplicativo</span>
          </md-list-item>

          <md-list-item v-if="isAdmin()" :to="{ name: 'TipoSensorIndex' }">
            <md-icon>sensors</md-icon>
            <span class="md-list-item-text">Tipos sensor</span>
          </md-list-item>

          <md-list-item
            v-if="isAdmin()"
            :to="{ name: 'EquipamentoTemplateIndex' }"
          >
            <md-icon>category</md-icon>
            <span class="md-list-item-text">Template</span>
          </md-list-item>

          <md-list-item v-if="isAdmin()" :to="{ name: 'DomainEventIndex' }">
            <md-icon>history</md-icon>
            <span class="md-list-item-text">Auditoria</span>
          </md-list-item>

          <md-list-item @click="$store.commit('setNotificationAsked', false)">
            <md-icon>notifications</md-icon>
            <span class="md-list-item-text">Notificação</span>
          </md-list-item>

          <!--                    <md-list-item :to="{name: 'acoes'}">-->
          <!--                        <md-icon>near_me</md-icon>-->
          <!--                        <span class="md-list-item-text">Ações</span>-->
          <!--                    </md-list-item>-->

          <!--                    <md-list-item @click="() => {}">-->
          <!--                        <md-icon>person</md-icon>-->
          <!--                        <span class="md-list-item-text">Perfil</span>-->
          <!--                    </md-list-item>-->
          <md-list-item @click="logout">
            <md-icon>exit_to_app</md-icon>
            <span class="md-list-item-text">Sair</span>
          </md-list-item>
        </md-list>
      </md-app-drawer>

      <md-app-content
        id="main"
        class=""
        :class="$store.state.style.paddingPage ? 'content' : 'no-padding'"
      >
        <slot />
        <BrowserPermission />
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import BrowserPermission from '@/components/browser-permissions/BrowserPermission.vue'
import { EventBus, Topics, Types } from '@/event-bus'
import http from '@/utils/http'
import { registerChannelListener } from '@/utils/web-socket'

import environment from '../environment'
import store from '../store'
import auth from '../utils/auth'

export default {
  name: 'Menu',
  components: { BrowserPermission },
  data: () => ({
    menuVisible: false,
    appName: environment.APP_NAME,
  }),
  computed: {
    nome: function () {
      return this.$store.state.auth.user.userName
    },
    deveExibirMenu: function () {
      return this.$store.state.style.toolbar
    },
    localName: function () {
      if (this.$route.params.localId) {
        return store.state.locais[this.$route.params.localId]?.nome
      }

      return null
    },
  },
  async beforeMount() {
    const locais = (await http.get('local')).locais
    const locaisById = locais.reduce((acc, local) => {
      acc[local.id] = local
      return acc
    }, {})

    this.$store.commit('setLocais', locaisById)
  },
  async mounted() {
    const userId = store.state.auth.user.id
    await registerChannelListener(
      'notification:' + userId,
      'ok',
      () => {},
      () => {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.INFO,
          message: 'Conectado as notificações',
        })
      }
    )
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible
    },
    isAdmin() {
      return auth.isAdmin()
    },
    async logout() {
      await this.$store.dispatch('logout')
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  padding-top: 0.5%;
  padding-bottom: 0;
}

.no-padding {
  margin: 0 !important;
  padding: 0 !important;

  height: 100%;
}
</style>

<style lang="scss" scoped>
.md-app {
  min-height: 350px;
  border: 1px solid rgba(#000, 0.12);
}

@media only screen and (max-width: 960px) {
  .md-title {
    font-size: 1rem;

    > span {
      font-size: 1rem;
    }
  }
}

// Demo purposes only
.md-drawer {
  width: 230px;
  max-width: calc(100vw - 125px);
}

.full-height {
  height: 100%;
}
</style>
